import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import LegalDocumentTnc from 'widgets/tnc';
import * as Styles from './styles';

function LegalTnc() {
    const { setShowHamburger } = useContext(MPosContext);

    const onClick = () => {
        setShowHamburger(true);
    };

    return (
        <Styles.Wrapper>
            <LegalDocumentTnc onClick={onClick} />
        </Styles.Wrapper>
    );
}

export default LegalTnc;
